import { createClient } from '@supabase/supabase-js'

const SUPABASE_KEY = 'sb_publishable_OHT6DxRuhxfYELWs-JlYgQ_l0MlJAJu' //'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxvZnZvbWFnaW1wdGhnZ21vcmZwIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODU4OTg2NzUsImV4cCI6MjAwMTQ3NDY3NX0.KnOabJDqi8hyPqerbIoKBvGGu0V8ZHpMuz6aC8BFzas'
const SUPABASE_URL = 'https://epmpqtojagdpkdkwzinu.supabase.co' //'https://lofvomagimpthggmorfp.supabase.co'

export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_KEY)
